<template>
  <div>
    <!-- <div class="grid-x container banner-description">
      <div class="large-12 cell">
        <h1 class="text-center">
          My Account
        </h1>
        <h5 class="text-center">
          Log in or register to create an account
        </h5>
      </div>
    </div> -->
    <div class="grid-x grid-padding-y">
      <div class="large-12 cell">
        <p class="text-center">&nbsp;</p>
      </div>
    </div>
    <div class="grid-container container first">
      <div class="grid-x grid-padding-x layout">
        <div class="cell medium-6 large-4 large-centered">
          <form name="loginForm" data-abide novalidate ref="f" class="">
            <div class="card-section">
              <div class="text-center h4">
                <router-link to="login" style="color: inherit;">
                  Sign In
                </router-link>
                <span>/</span>
                <router-link to="register" style="color: inherit;">
                  Register
                </router-link>

                
              </div>
              <div class="padding-top-1 padding-bottom-1">
<p style="font-size: 1rem;">
                  Enter your email address and password to
access your account.
                </p>

              </div>

              <label>
                
                <input
                  name="UserName"
                  type="email"
                  placeholder="Email"
                  autofocus
                  v-model="model.UserName"
                  required
                />
                <span class="form-error">
                  This field is required.
                </span>
              </label>
              <label>
                
                <input
                  name="Password"
                  type="password"
                  placeholder="Password"
                  v-model="model.Password"
                  required
                />
                <span class="form-error">
                  This field is required.
                </span>
              </label>
              <p class="help-text" id="exampleHelpTextNothing">
                <router-link
                  :to="{ name: 'forgotPassword' }"
                  class="float-left"
                >
                  Forgot Password?
                </router-link>
                <router-link to="register" class="float-right">
                  New Customer? Sign up &#x2192;
                </router-link>
              </p>
              <p style="clear: both;">&nbsp;</p>
              <p>
                <input
                  id="login"
                  name="login"
                  type="submit"
                  class="button expanded radius large"
                  value="Sign In"
                />
              </p>
              <div v-show="errored" class="alert callout">
                <p v-if="erroredEmailNotConfirmed">
                  Email is not confirmed yet. <br />
                  Please try again or contact administrator.
                </p>
                <p v-else>
                  Email or Password incorrect. <br />
                  Please try again.
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="container"></div>
  </div>
</template>

<script>
import { EventBus } from '@/app/event-bus';

import userInfoService from "@/app.user/services/main-service.js";
import accountRepository from "@/app.account/services/main-service.js";

export default {
  name: "appLogin",
  mixins: [require("@/app/mixins/foundation")],
  data() {
    return {
      model: {},
      isValid: false,
      loading: false,
      errored: false,

      erroredEmailNotConfirmed: false,

      userInfo: {}, //Test
    };
  },
  mounted() {
    let _this = this;

    $(this.$refs.f)
      .on("invalid.zf.abide", function() {
        _this.isValid = false;
      })
      .on("formvalid.zf.abide", function() {
        _this.isValid = true;
      })
      .on("submit", function(ev) {
        ev.preventDefault();

        if (_this.isValid) {
          _this.onSubmit();
        } else {
          // console.log("error");
        }
      });
  },
  methods: {
    async onSubmit() {
      this.$refs.f.login.disabled = true;
      let _this = this;

      try {
        const { data } = await accountRepository.login({
          UserName: this.model.UserName,
          Password: this.model.Password,
        });

        if (data.succeeded) {
          _this.userInfo = data.userInfo;
          userInfoService.setUserInfo(data.userInfo);
          sessionStorage.setItem("Roles", data.roles);
          sessionStorage.setItem("Claims", data.claims);
            if(data.jwtToken) {
                // 储存 token
                localStorage.token = data.jwtToken;
            }
          EventBus.$emit('refreshUserInfo');

          _this.$router.push("/");
        } else {
          this.model.Password = '';

          if (data.errors.length>0){
            let error = data.errors[0];
            this.erroredEmailNotConfirmed = error==='emailNotActivated';
          }
          this.errored = true;
        }
      } catch (error) {
        this.errored = true;
      } finally {
        this.loading = this.$refs.f.login.disabled = false;
      }

      if (this.errored){
          setTimeout(()=>_this.errored=false, 9000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  padding-top: 1.5rem;
  .large-centered {
    margin: 0 auto;
  }
}

.banner-description {
  background-image: linear-gradient(to bottom right, #cec9c9, white);
}

.router-link-exact-active {
  text-decoration: underline;
}

.alert.callout {
  border: none;
}
</style>
